import { gettext } from '@eventbrite/i18n';

export const NOTIFICATION_BAR_LABEL = gettext('Need to make some updates?');
export const EDIT_ORGANIZER_PROFILE = gettext('Edit organizer profile');
